import React, {useState, useRef, useEffect} from "react";
import {CircularProgressCustom} from "./common-components/CircularProgressCustom";
import {useQuery} from "@apollo/react-hooks";
import {GET_CUSTOM_FABRICATION} from "./../../services/graphql-query";
import {Container, Row, Col, Modal, Button} from "react-bootstrap";
import {apiUrl} from "./../../services/constants";
import "../../css/app.css";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import validator from "validator";
import Swal from "sweetalert2";
import {Backdrop, CircularProgress} from "@mui/material";
import {Link} from "react-router-dom";
import ReactMarkdown from 'react-markdown';
import ImageSlider from "./common-components/ImageSlider";
import ImageSlider2 from "./common-components/ImageSlider2";

const CustomFabrication = () => {
    const {loading, error, data} = useQuery(GET_CUSTOM_FABRICATION);
    const [isShowModal, setShowModal] = useState(false);
    const [email, setEmail] = useState("");
    const [isQuote, setQuote] = useState("");
    const [isEmailError, setIsEmailError] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [isCaptchaExpired, setIsCaptchaExpired] = useState(false);
    const [token, setToken] = useState(null);
    const [isOpenBackdrop, setIsOpenBackdrop] = useState(false);
    const captchaRef = useRef(null);

    console.log(data);
    const FormattedText = ({content}) => {
        return <ReactMarkdown>{content}</ReactMarkdown>;
    }


    useEffect(() => {
        if (isCaptchaExpired) setToken(null);
    }, [isCaptchaExpired]);

    if (loading) return <CircularProgressCustom/>;

    if (error || data.customFabrications.data.length === 0) {
        return (
            <>
                <h1>Sorry... We have some error</h1>
            </>
        );
    }

    const getImageParams = (imageProps) => {
        if (imageProps.data === null) {
            return {
                url: '',
                name: ''
            };
        }
        return Array.isArray(imageProps.data) ? imageProps.data[0].attributes : imageProps.data.attributes;
    }

    const getImagesParams = (imageProps) => {
        if (imageProps.data === null) {
            return [
                {
                    url: '',
                    name: ''
                }
            ];
        }

        return  imageProps.data.map((data) => {
            return data.attributes;
        });
    }

    const getYouTubeVideoID = (url) => {
        const regex = /(?:youtube\.com\/.*v=|youtu\.be\/)([^&?]+)/;
        const match = url.match(regex);
        return match ? match[1] : null;
    }

    const customFabrications = data.customFabrications.data[0].attributes;

    const title = customFabrications?.PageTitle;
    const ImageBanner = getImageParams(customFabrications?.ImageBanner);

    const LaserCuttingImage = getImageParams(customFabrications?.LaserCuttingImage);
    const LaserWeldingImage = getImageParams(customFabrications?.LaserWeldingImage);
    const LaserEtchingImage = getImageParams(customFabrications?.LaserEtchingImage);
    const BendingAndHardwareInsertionImage = getImageParams(customFabrications?.BendingAndHardwareInsertionImage);
    const PowderCoatingImage = getImageParams(customFabrications?.PowderCoatingImage);
    const CustomFabricationProjectGalleryImage = getImagesParams(customFabrications?.CustomFabricationProjectGalleryImage);
    const CustomLightingProjectsImage = getImagesParams(customFabrications?.CustomLightingProjectsImage);

    const RequestQuote = () => {
        setShowModal(true)
    }
    const handleVerificationSuccess = token => {
        setToken(token);
        if (token) setIsCaptchaExpired(false);
    };
    const handleEmailSend = () => {
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            },
            body: JSON.stringify({
                email: email,
                quote: isQuote
            })
        };

        setIsClicked(true);
        if (!validator.isEmail(email)) {
            setIsEmailError(true);
        } else {
            setIsEmailError(false);
        }

        if (validator.isEmail(email) && token) {
            setIsOpenBackdrop(true);
            fetch(`/api/quote/send`, requestOptions)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setIsClicked(false);
                    setEmail("");
                    setToken(null);
                    setQuote("");
                    setIsOpenBackdrop(false);
                    captchaRef.current.resetCaptcha();

                    if (result.status === "success") {
                        Swal.fire("Success!", result.msg, "success");
                    } else {
                        Swal.fire("Oops...", result.msg, "error");
                    }
                }).catch(err => console.log(err));
        }
    };

    return (
        <>
            <div className="custom-fabrication-container-header">
                <div>
                    <FormattedText content={title}/>
                </div>
                <img src={apiUrl + ImageBanner.url} alt={ImageBanner.name}/>
            </div>

            <Container className="custom-fabrication-container-body">
                <Row className="p-5">
                    <div className="text-center">
                        <FormattedText content={customFabrications?.Capabilities}/>
                    </div>
                    <div>
                        <FormattedText content={customFabrications?.CapabilitiesDescription}/>
                    </div>
                </Row>


                <Row className="pt-5">
                    <Col></Col>
                    <Col>
                        <iframe width="560" height="315"
                                src={"https://www.youtube.com/embed/" + getYouTubeVideoID(customFabrications?.YoutubeVideoUrl)}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen></iframe>
                    </Col>
                    <Col className="vertical-center-box">
                        <button className='quote-item d-flex align-items-center justify-content-center'
                                onClick={() => RequestQuote()}>Request Quote
                        </button>
                    </Col>
                </Row>
                <Row className="text-center pt-5 pb-2">
                    <FormattedText content={customFabrications?.ServicesTitle}/>
                </Row>
                <Row className="text-center">
                    <Col>
                        <FormattedText content={customFabrications?.ContractManufacturingTtitle}/>
                        <FormattedText content={customFabrications?.ContractManufacturingDescription}/>
                    </Col>
                    <Col>
                        <FormattedText content={customFabrications?.PrototypingTitle}/>
                        <FormattedText content={customFabrications?.PrototypingDescription}/>
                    </Col>
                    <Col>
                        <FormattedText content={customFabrications?.ThreeDModelingTitle}/>
                        <FormattedText content={customFabrications?.ThreeDModelingDescription}/>
                    </Col>
                </Row>

                <Row className="p-3">
                    <Col className="vertical-center-box">
                        <div>
                            <div className="text-center">
                                <FormattedText content={customFabrications?.LaserCutingTitle}/>
                            </div>
                            <div>
                                <FormattedText content={customFabrications?.LaserCuttingDescriptions}/>
                            </div>
                        </div>
                    </Col>
                    <Col xs={4} className="text-center">
                        <img className="image-desc" src={apiUrl + LaserCuttingImage.url} alt={LaserCuttingImage.name}/>
                    </Col>
                </Row>
                <Row className="p-3">
                    <Col xs={4} className="text-center">
                        <img className="image-desc" src={apiUrl + LaserWeldingImage.url} alt={LaserWeldingImage.name}/>
                    </Col>
                    <Col className="vertical-center-box">
                        <div>
                            <div className="text-center">
                                <FormattedText content={customFabrications?.LaserWeldingTitle}/>
                            </div>
                            <div>
                                <FormattedText content={customFabrications?.LaserWeldingDescription}/>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="p-3">
                    <Col className="vertical-center-box">
                        <div>
                            <div className="text-center">
                                <FormattedText content={customFabrications?.BendingAndHardwareInsertionTitle}/>
                            </div>
                            <div>
                                <FormattedText content={customFabrications?.BendingAndCuttingInsertionDescription}/>
                            </div>
                        </div>
                    </Col>
                    <Col xs={4} className="text-center">
                        <img className="image-desc" src={apiUrl + BendingAndHardwareInsertionImage.url}
                             alt={BendingAndHardwareInsertionImage.name}/>
                    </Col>
                </Row>

                <Row className="p-3">
                    <Col xs={4} className="text-center">
                        <img className="image-desc" src={apiUrl + LaserEtchingImage.url} alt={LaserEtchingImage.name}/>
                    </Col>
                    <Col className="vertical-center-box">
                        <div>
                            <div className="text-center">
                                <FormattedText content={customFabrications?.LaserEtching}/>
                            </div>
                            <div>
                                <FormattedText content={customFabrications?.LaserEtchingDescription}/>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="p-3">
                    <Col className="vertical-center-box">
                        <div>
                            <div className="text-center">
                                <FormattedText content={customFabrications?.PowderCoatingTitle}/>
                            </div>
                            <div>
                                <FormattedText content={customFabrications?.PowderCoatingDescription}/>
                            </div>
                        </div>
                    </Col>
                    <Col xs={4} className="text-center">
                        <img className="image-desc" src={apiUrl + PowderCoatingImage.url}
                             alt={PowderCoatingImage.name}/>
                    </Col>
                </Row>

                <Row className="p-3">
                    <Col xs={6} className="text-center">
                        <FormattedText content={customFabrications?.CustomFabricationProjectGallery}/>
                        {/*<Link to='/products'>*/}
                        <ImageSlider images={CustomFabricationProjectGalleryImage} slidesPerView={'auto'} />
                    </Col>
                    <Col xs={6} className="text-center">
                        <FormattedText content={customFabrications?.CustomLightingProjects}/>
                        {/*<Link to='/custom-work'>*/}
                        <ImageSlider2 images={CustomLightingProjectsImage} slidesPerView={1} />
                    </Col>
                </Row>
            </Container>

            <Modal
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={isShowModal}
                onHide={() => setShowModal(false)}
            >
                <Modal.Header closeButton>
                    <h5 className="modal-title" id="exampleModalLabel">
                        Specification
                    </h5>
                </Modal.Header>
                <Modal.Body>
                    <form
                        className="form-floating mb-3"
                        id="form"
                        noValidate
                    >
                        <input
                            name="email"
                            type="email"
                            className={`form-control ${isEmailError
                                ? "is-invalid"
                                : isClicked && "is-valid"
                            }`}
                            id="floatingInput"
                            placeholder="name@gmail.com"
                            defaultValue={email}
                            onChange={e => {
                                setEmail(e.target.value);
                            }}
                        />
                        <label htmlFor="floatingInput">Email address</label>
                        {isEmailError ? (
                            <div className="invalid-feedback">
                                Please enter a valid email.
                            </div>
                        ) : (
                            isClicked && (
                                <div className="valid-feedback">
                                    Looks good!
                                </div>
                            )
                        )}
                        <textarea name='quote' className='mt-2' style={{width: "100%", border: "1px solid #ced4da"}}
                                  value={isQuote} onChange={(e) => setQuote(e.target.value)} rows={4}></textarea>
                        <div className="mt-2">
                            <HCaptcha
                                ref={captchaRef}
                                sitekey="8d147cae-36a3-40e9-a9c5-6f5742ce5219"
                                onVerify={token =>
                                    handleVerificationSuccess(token)
                                }
                                onExpire={() => setIsCaptchaExpired(true)}
                            />
                        </div>
                        {!token && isClicked ? (
                            <p className="text-danger">
                                This is hCaptcha for human testing.
                            </p>
                        ) : (
                            isCaptchaExpired && (
                                <p className="text-danger">
                                    The hCaptcha for human testing has expired.
                                </p>
                            )
                        )}
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={() => setShowModal(false)}
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                        id="closeModal"
                    >
                        Close
                    </Button>
                    <Button
                        onClick={() => handleEmailSend()}
                        type="submit"
                        className="btn btn-dark"
                    >
                        Send
                    </Button>
                </Modal.Footer>
            </Modal>
            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: theme => theme.zIndex.drawer + 1
                }}
                open={isOpenBackdrop}
            >
                <CircularProgress color="inherit"/>
            </Backdrop>
        </>


    );
};

export default CustomFabrication;
